(function () {
  function normalize(value) {
    if (!value) return '';

    var normalized = value.trim();

    try {
      normalized = decodeURI(normalized);
    } catch (error) {
      // Keep the original value if it cannot be decoded.
    }

    return normalized.replace(/\/$/, '');
  }

  function hasMeaningfulFallback(link) {
    var visibleText = link.textContent
      .replace(/\s+/g, ' ')
      .trim();

    var meaningfulImage = link.querySelector(
      'img[alt]:not([alt=""])'
    );

    return Boolean(visibleText || meaningfulImage);
  }

  function removeUrlLabel(link) {
    if (
      !link ||
      link.nodeType !== 1 ||
      !link.matches('a[aria-label][href]')
    ) {
      return;
    }

    var label = normalize(
      link.getAttribute('aria-label')
    );

    var rawHref = normalize(
      link.getAttribute('href')
    );

    var absoluteHref = normalize(link.href);

    var labelIsUrl =
      label === rawHref ||
      label === absoluteHref;

    /*
     * Only remove the generated label when the link
     * already has descriptive text or image alt text.
     */
    if (labelIsUrl && hasMeaningfulFallback(link)) {
      link.removeAttribute('aria-label');
    }
  }

  function processLinks(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) {
      return;
    }

    if (root.matches?.('a[aria-label][href]')) {
      removeUrlLabel(root);
    }

    root
      .querySelectorAll?.('a[aria-label][href]')
      .forEach(removeUrlLabel);
  }

  processLinks(document);

  /*
   * The third-party script may add labels after page load,
   * so continue watching for those changes.
   */
  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (
        record.type === 'attributes' &&
        record.attributeName === 'aria-label'
      ) {
        removeUrlLabel(record.target);
      }

      record.addedNodes.forEach(processLinks);
    });
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
})();